import { useState } from 'react'
import {Field, connect} from 'formik'
import {gaEvent, parseCents, sanitizeMoney} from 'shared'
import classNames from 'classnames'

export const AmountField = connect(({formik, className, currencySymbol = null, autoFocus = false}) => {
  const [value, setValue] = useState(formik.initialValues.amount_cents / 100)

  return <Field name='amount_cents'>
    {({field: {onChange: unusedOnChange, value: unusedValue, ...fieldProps}, form}) =>
      <>
        <input
          autoFocus={autoFocus}
          className={classNames(className, { 'field-with-error': form.errors.amount_cents })}
          size={8}
          type='text'
          inputMode='decimal'
          value={value}
          onChange={(event) => {
            const donationCents = parseCents(event.target.value)
            form.setFieldValue(fieldProps.name, donationCents)
            setValue(sanitizeMoney(event.target.value))
          }}
          {...fieldProps}
          onBlur={(event) => {
            if (formik.initialValues.amount_cents !== formik.values.amount_cents) {
              gaEvent('engagement', 'change amount_input', sanitizeMoney(event.target.value))
            }
            // touchedness must be set manually if onBlur is overridden
            form.setFieldTouched('amount_cents', true)
          }}
        />
        {currencySymbol && <span className='input-currency-symbol'>{currencySymbol}</span>}
        {form.errors.amount_cents && form.touched.amount_cents && <div className='help-inline'>{form.errors.amount_cents}</div>}
      </>
    }
  </Field>
})
